import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="haut" className="flex min-h-[calc(100svh-2rem)] bg-brand-paper px-4 py-5 text-center sm:py-6" data-id="element-85" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-86" data-mp="23x4lkoea6y04">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-sageInk sm:text-xs" data-id="element-87" data-mp="30k95sg8arrk0">
          MÉTHODE COMPLÈTE POUR PROFESSEURS DE PILATES REFORMER
        </p>
        <h1 className="mx-auto max-w-4xl text-[1.8rem] font-black leading-[1.05] tracking-tight text-brand-slate sm:text-[2.6rem] md:text-[3rem]" data-id="element-88" data-mp="2rsgzmhqb34l8">
          Enseignez une Année Complète de <span className="italic text-brand-terracottaInk" data-id="element-89" data-mp="3k9ba66rkjf91">Pilates Reformer</span> avec
          Seulement 5 Minutes de Préparation
        </h1>
        <p className="mx-auto mt-2.5 max-w-3xl text-[13px] leading-snug text-brand-gray sm:text-sm md:text-base" data-id="element-90" data-mp="2fgblt3fwmdce">
          Pilates Reformer Prêt™️ rassemble 6 niveaux de progression complète, prêts à enseigner : vocabulaire
          technique, repères visuels, script de coaching et exercices classés par difficulté pour chaque séance. Ouvrez
          le bon niveau, suivez la séquence, enseignez en confiance.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/3ZbG21TZGeMuxYfGM4Awkz/ChatGPT_Image_9_sept_2026,_22_48_29-Photoroom.png" alt="Le pack Pilates Reformer Prêt : les six volumes de la collection, une tablette affichant une séquence Reformer, un écran d'ordinateur et un mobile présentant une fiche d'exercice" className="mx-auto my-1.5 h-[35svh] w-auto max-w-full object-contain sm:h-[39svh] md:h-[42svh]" data-id="element-91" data-mp="2z1oh7shc60p1" />
        <div className="flex w-full flex-col items-center" data-id="element-92" data-mp="18rlk7q2hx2lp">
          <CTAButton className="min-w-[210px] px-4 py-2.5 text-[10px] sm:min-w-[236px] sm:px-5 sm:py-2.5 sm:text-[11px]" data-id="element-93" data-mp="18tg2sxqaoimm">
            JE PRENDS PILATES REFORMER PRÊT
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-94" data-mp="3duigjm2psxsj">
            ✓ Accès numérique immédiat <span className="px-1 text-brand-terracottaInk" data-id="element-95" data-mp="3mtckxymaesgn">·</span> ✓ 6 niveaux, du
            Fondamentaux à l&apos;Avancé II <span className="px-1 text-brand-terracottaInk" data-id="element-96" data-mp="3rre3mifswprl">·</span> ✓ Prêt à imprimer
          </p>
        </div>
      </motion.div>
    </section>;
}